<template>
  <div class="bg-white p-6 rounded-xl border-2 border-gray-200">
    <h3 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
      <span>🖨️</span>
      <span>Aperçu impression thermique</span>
    </h3>

    <!-- Simulation de ticket thermique -->
    <div class="bg-gray-50 p-4 rounded-lg border border-gray-300 font-mono text-center max-w-[300px] mx-auto">
      <!-- Logo/Header -->
      <div class="text-xs text-gray-600 mb-2">── VOTRE AGENCE ──</div>

      <!-- Icône + Numéro de ticket -->
      <div class="my-4">
        <!-- Icône pixel art simulée -->
        <div v-if="iconName" class="inline-block mb-2">
          <div class="text-4xl">{{ getIconEmoji(iconName) }}</div>
          <div class="text-[8px] text-gray-500 mt-1">{{ iconName }}</div>
        </div>

        <!-- Numéro de ticket selon le mode -->
        <div class="text-4xl font-black text-gray-800">
          <template v-if="displayMode === 'icon_number'">
            {{ ticketNumber }}
          </template>
          <template v-else-if="displayMode === 'icon_prefix_number'">
            {{ prefix }}-{{ ticketNumber }}
          </template>
          <template v-else-if="displayMode === 'number_only'">
            {{ ticketNumber }}
          </template>
          <template v-else-if="displayMode === 'prefix_number'">
            {{ prefix }}-{{ ticketNumber }}
          </template>
          <template v-else>
            {{ prefix }}-{{ ticketNumber }}
          </template>
        </div>

        <!-- Nom de la file -->
        <div class="text-xs text-gray-600 mt-2 font-bold">
          {{ queueName || 'Nom de la file' }}
        </div>
      </div>

      <!-- Date/Heure -->
      <div class="text-[10px] text-gray-500 border-t border-gray-300 pt-2 mt-2">
        {{ currentDate }} - {{ currentTime }}
      </div>

      <!-- Footer -->
      <div class="text-[8px] text-gray-400 mt-2">
        Merci de votre patience
      </div>
    </div>

    <!-- Légende des modes -->
    <div class="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
      <div class="text-xs font-bold text-blue-700 mb-2">📋 Modes d'affichage :</div>
      <div class="space-y-1 text-xs text-blue-600">
        <div><strong>Icône + Préfixe + Numéro :</strong> 🐰 BR-001</div>
        <div><strong>Icône + Numéro :</strong> 🐰 001</div>
        <div><strong>Préfixe + Numéro :</strong> BR-001</div>
        <div><strong>Numéro uniquement :</strong> 001</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TicketIconPreview',
  props: {
    iconName: {
      type: String,
      default: null
    },
    displayMode: {
      type: String,
      default: 'icon_prefix_number'
    },
    prefix: {
      type: String,
      default: 'BR'
    },
    queueName: {
      type: String,
      default: 'Service'
    }
  },
  data() {
    return {
      ticketNumber: '001',
      currentDate: new Date().toLocaleDateString('fr-FR'),
      currentTime: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    }
  },
  methods: {
    getIconEmoji(iconName) {
      const emojiMap = {
        'rabbit': '🐰',
        'turtle': '🐢',
        'star': '⭐',
        'heart': '❤️',
        'prescription': '📋',
        'cross': '➕',
        'capsule': '💊',
        'syringe': '💉',
        'heart-pulse': '💓',
        'stethoscope': '🩺',
        'microscope': '🔬',
        'flask': '⚗️',
        'thermometer': '🌡️',
        'bandage': '🩹',
        'clipboard': '📋',
        'calendar': '📅',
        'user-check': '✅',
        'droplet': '💧',
        'eye': '👁️',
        'activity': '📊'
      }
      return emojiMap[iconName] || '❓'
    }
  }
}
</script>
